import * as React from 'react';
import { BaseModel } from './BaseModel';

export interface ISettledFormModelProps {
    id: string;
    MonthlySW: boolean;
    MonthlyUSTRect: boolean;
    MonthlyUSTSpill: boolean;
    MonthlyPPM: boolean;
    ShopInspection: boolean;
    DailyForm: boolean;
    PlantPreventive: boolean;
    MonthlySpillLogs: boolean;
    QTRVisual: boolean;
    MonthlySPCC: boolean;
    InCompleteOutfalls: string[];
    Outfalls: IOutfall;
}

export interface IOutfall {
    outfall?: boolean;
}

export class SettledFormModel extends BaseModel<ISettledFormModelProps> {
    constructor(props: ISettledFormModelProps) {
        super(props);
    }

    static resource = 'settled-forms';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/SettledFormModel.tsx